
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apps/open",
      function () {
        return require("private-next-pages/apps/open.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apps/open"])
      });
    }
  